import { CreateNewObservationsCategoryForm } from "src/features/Admin/ObservationsCategories/components/CreateNewObservationsCategoryForm";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogTitle
} from "src/components/ui/dialog";
import { useSearchParams } from "react-router-dom";
import { useObservationCategory } from "src/features/Admin/ObservationsCategories/hooks/useObservationCategory";

type CreateNewCategoryModalProps = {
	test?: string;
	isOpen: boolean;
	onClose: () => void;
};

const CreateNewCategoryModal = ({
	onClose,
	isOpen
}: CreateNewCategoryModalProps) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const categoryId =
		parseInt(searchParams.get("categoryId") || "") || undefined;

	const { data: category, isInitialLoading: isLoadingCategory } =
		useObservationCategory(categoryId, {
			enabled: Boolean(categoryId)
		});

	const handleClose = () => {
		onClose?.();
		setSearchParams({});
	};

	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
			<DialogContent className="p-6 w-[80%] max-w-[979px] rounded-xl">
				<DialogTitle className="font-heading text-lg font-medium text-foreground mb-4">
					{categoryId ? "Edit category" : "Create new category"}
				</DialogTitle>

				<DialogDescription className="sr-only">
					Use this dialog to create or update an observation category.
				</DialogDescription>

				<CreateNewObservationsCategoryForm
					defaultValues={{
						name: category?.name || "",
						audienceGroupIds: category?.audienceGroups?.map((g) => g.id) ?? []
					}}
					categoryId={categoryId}
					onClose={handleClose}
					isLoading={isLoadingCategory}
				/>
			</DialogContent>
		</Dialog>
	);
};

export default CreateNewCategoryModal;
